// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { SentenceDatesComponents } from "../SentenceDates/types";
import { CardsWrapper } from "./CardsWrapper";
import { DateAdjustment } from "./DateAdjustment";
import { DateCard } from "./DateCard";
import { DateCardBodyWrapper } from "./DateCardBodyWrapper";
import { DateCardHeadingWrapper } from "./DateCardHeadingWrapper";
import { DateDescription } from "./DateDescription";
import { DateLabel } from "./DateLabel";
import { DateValue } from "./DateValue";
import { DateValueSupplemental } from "./DateValueSupplemental";
import { HiddenDatesCard } from "./HiddenDatesCard";
import { SectionHeading } from "./SectionHeading";
import { Wrapper } from "./Wrapper";

export const defaultComponents: SentenceDatesComponents = {
  SectionWrapper: Wrapper,
  SectionHeading,
  CardsWrapper,
  DateCard,
  DateDescription,
  DateLabel,
  DateValue,
  DateValueSupplemental,
  DateCardHeadingWrapper,
  DateCardBodyWrapper,
  DateAdjustment,
  HiddenDatesCard,
};
